const initialState = {
  data: [],
  loading: false,
  meta: {
    page: 1,
    pageSize: 10,
    total: 0,
    totalPages: 0
  }
}

export default function apiKeysReducer (state = initialState, { type, payload }) {
  switch (type) {
    case 'api_keys/set_state':
      return {
        ...state,
        ...payload
      }
    default:
      return state
  }
}
